import { Dispatch, Middleware } from "redux";

import getFloorId from "../getters/floor_getters/get_floor_id";
import getProjectId from "../getters/project_getters/get_project_id";
import { dropCachedElementPages } from "../autodesk_forge_services/geometry_cache";
import { isBigBimViewerPerformanceOn } from "../utilities/big_bim_viewer_performance";
import { DEVIATION_MARKED_AS_NOT_RESOLVED } from "../../events/viewer/deviation_marked_as_not_resolved";
import { DEVIATION_MARKED_AS_RESOLVED } from "../../events/viewer/deviation_marked_as_resolved";
import { ELEMENTS_EDITED } from "../../events/viewer/elements_edited";
import { ELEMENTS_EXCLUDE_FROM_ANALYSIS_UPDATED } from "../../events/viewer/elements_exclude_from_analysis_updated";
import { ELEMENTS_PARTIAL_PROGRESS_UPDATED } from "../../events/viewer/elements_partial_progress_updated";
import { ELEMENTS_STATUSES_UPDATED } from "../../events/viewer/elements_statuses_updated";
import { ELEMENTS_VERIFIED_UPDATED } from "../../events/viewer/elements_verified_updated";
import { EXPORTED_TO_BCF } from "../../events/viewer/exported_to_bcf";
import { PUSH_TO_BIM_UNDONE } from "../../events/viewer/push_to_bim_undone";
import { PUSHED_ALL_TO_BIM } from "../../events/viewer/pushed_all_to_bim";
import { PUSHED_TO_BIM } from "../../events/viewer/pushed_to_bim";

import type { ReduxStore } from "../reducers/root_reducer";

const ELEMENT_EDITS = new Set<string>([
  DEVIATION_MARKED_AS_NOT_RESOLVED,
  DEVIATION_MARKED_AS_RESOLVED,
  ELEMENTS_EDITED,
  ELEMENTS_EXCLUDE_FROM_ANALYSIS_UPDATED,
  ELEMENTS_PARTIAL_PROGRESS_UPDATED,
  ELEMENTS_STATUSES_UPDATED,
  ELEMENTS_VERIFIED_UPDATED,
  EXPORTED_TO_BCF,
  PUSH_TO_BIM_UNDONE,
  PUSHED_ALL_TO_BIM,
  PUSHED_TO_BIM
]);

/**
 * The browser keeps big floors' element pages for a few minutes (see geometry_cache). Once the user edits a
 * floor's elements those pages are out of date, so they're dropped: the next load reads the edit back.
 */
const elementCacheMiddleware: Middleware<object, ReduxStore> = store => (next: Dispatch) => event => {
  const result = next(event);
  if (ELEMENT_EDITS.has(event?.type) && isBigBimViewerPerformanceOn()) {
    const state = store.getState();
    const payload = event.payload as { floorId?: string, firebaseFloorId?: string } | undefined;
    const projectId = getProjectId(state, {});
    const floorId = payload?.floorId || payload?.firebaseFloorId || getFloorId(state, {});
    if (projectId && floorId) {
      dropCachedElementPages(projectId, floorId);
    }
  }
  return result;
};

export default elementCacheMiddleware;
